<template>
  <v-card v-if="incidentSource.resolution" class="bg-green-lighten-5 mt-4" flat>
    <v-card-text>
      <div
        class="d-flex align-center ga-2 text-uppercase font-weight-bold text-medium-emphasis font-size-11 mb-3">
        <v-icon color="success" size="x-small">mdi-circle</v-icon>
        Врегулювання
      </div>
      <v-divider class="mb-4 border-opacity-10"></v-divider>

      <v-row>
        <v-col cols="12" md="6">
          <b-input-date
            :model-value="incidentSource.resolution.resolvedDate ?? undefined"
            hide-details
            label="Дата врегулювання"
            readonly></b-input-date>
        </v-col>

        <v-col cols="12" md="6">
          <b-input-number
            :model-value="incidentSource.resolution.damageCostAfterResolution"
            hide-details
            label="Сума залишкових збитків, грн"
            rank-spacing
            readonly></b-input-number>
        </v-col>

        <v-col cols="12">
          <b-textarea
            :model-value="incidentSource.resolution.resolutionMethod"
            hide-details
            label="Механізм врегулювання, який застосовано"
            readonly
            rows="4"></b-textarea>
        </v-col>

        <v-col cols="12">
          <b-textarea
            :model-value="incidentSource.resolution.processImprovements"
            hide-details
            label="Що потрібно покращити в бізнес-процесі, для мінімізації в подальшому таких інцидентів"
            readonly
            rows="4"></b-textarea>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts" setup>
import { BInputDate, BInputNumber, BTextarea } from 'best-modules/components'
import { useIncident } from '../Incident'

defineOptions({
  name: 'ResolutionBlock',
})

const { incidentSource } = useIncident()
</script>
